import { createSlice } from '@reduxjs/toolkit'

interface layoutsettingstype {
  administration_email: string
  google_recaptcha: {
    label: any
    value: any
  }
  application_title: string
  primary_color: '#9751F2'
  secondary_color: '#1DB8CE'
  recaptcha_secret_key: string
  recaptcha_site_key: string
  site_address: string
  site_title: string
  login_background_image: string
  logo: string
  loading_animation: string
  favicon: string
}

const initialState = {
  id: '',
  administration_email: '',
  google_recaptcha: {
    label: '',
    value: '',
  },
  application_title: '',
  primary_color: '#9751F2',
  secondary_color: '#1DB8CE',
  recaptcha_secret_key: '',
  recaptcha_site_key: '',
  site_address: '',
  site_title: '',
  login_background_image: '',
  logo: '',
  loading_animation: '',
  favicon: '',
}

const layoutsettingsSlice = createSlice({
  name: 'layoutsettings',
  initialState,
  reducers: {
    setlayoutsettings: (state, { payload }) => payload,
  },
})

export const { setlayoutsettings } = layoutsettingsSlice.actions

export default layoutsettingsSlice.reducer
